import {
    Inject,
    ISimpleControllerConfiguration,
    ResourceItem,
    SimpleBaseController,
} from "../../../modules/@denishussar/html5-game-engine";

import * as PIXI from 'pixi.js'
import 'pixi-spine'

export interface ISpineControllerOptions {
    key: string;
    url: string;
    animations: string[];
}

export class SpineAnimationBaseController extends SimpleBaseController {
    $model: any

    protected _spineData: PIXI.spine.core.SkeletonData;
    protected _spine: PIXI.spine.Spine;

    public currAnimation: string = '';

    public constructor(@Inject private _options: ISpineControllerOptions) {
        super('SpineAnimationBaseController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        const key = this._options.key;
        const url = this._options.url;

        const resources = {}
        resources[key] = new ResourceItem(key, url);

        return {
            resources: resources
        };
    }

    protected onInitialize(): void {
        this._spineData = this.resourcesLoader.loader.resources[this._options.key]?.spineData ?? null;

        //console.log(this._spineData);

        if (!this._spineData) {
            throw new Error(`Could not load spineData ${this._options.url}`);
        }

        this._spine = new PIXI.spine.Spine(this._spineData);
        this.display.addChild(this._spine);

        for (const index in this._options.animations) {
            this._spine.state.addAnimation(0, this._options.animations[index], false, 0);
        }

        this.visible = false;
        this._spine.state.setEmptyAnimation(0, 0);
    }

    public setAnimation(key: string, loop: boolean): void {
        if (this._spine && this._spine.state) {
            if (this._spine.state.hasAnimation(key)) {
                if (this.currAnimation !== key) {
                    this.visible = true;
                    this._spine.state.setAnimation(0, key, loop);
                    this.currAnimation = key;
                }
            } else {
                this.visible = false;
            }
        }
    }
}
